import React, { useCallback } from 'react';
import { FileUploadListItem } from './FileUploadListItem';
import { StyledUploadListContainer } from './styles';
const defaultTranslateFn = (key) => key;
const defaultOnCancel = () => {
    //Do nothing
};
export const FileUploadList = ({ files, shouldShowCompleted = false, shouldHideThumbnail, progressBarColor, translateFn = defaultTranslateFn, onCancel = defaultOnCancel, onRetry }) => {
    const fileList = files.filter(file => shouldShowCompleted || !file.isDone || file.isUploadFailed);
    const onCancelCallback = useCallback((id) => onCancel(id), [onCancel]);
    const onTranslateFnCallback = useCallback((key, options) => translateFn(key, options), [translateFn]);
    const itemData = {
        files: fileList,
        onCancel: onCancelCallback,
        translateFn: onTranslateFnCallback
    };
    return (React.createElement(StyledUploadListContainer, null,
        React.createElement("div", { style: { width: '100%', height: '100%', overflow: 'auto' } }, itemData.files.map(file => (React.createElement(FileUploadListItem, { shouldHaveBorder: true, key: file.id, progressBarColor: progressBarColor, shouldHideThumbnail: shouldHideThumbnail, file: file, onCancel: itemData.onCancel, translateFn: itemData.translateFn, onRetry: onRetry }))))));
};
//# sourceMappingURL=FileUploadList.js.map